export function getThumbnailLink(pdfLink: string): string {
    return pdfLink.replace('.pdf', '_thumb.png');
}
